var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("" + (_vm.isApple == true ? 'index-cont-phone' : 'index-cont'))},[(_vm.imgShow)?_c('img',{attrs:{"src":_vm.imgPath,"pathName":_vm.pathName},on:{"click":_vm.handleBack}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }